<template>
  <div class="detail-container">
    <!-- 功能区域 -->
    <section
      v-if="checkPermission('资料:查看材料链接', permList)
        || checkPermission('电子材料:发送邮件通知', permList)
        || checkPermission('电子材料:生成调查表', permList)
        || checkPermission('电子材料:生成调查函', permList)
        || checkPermission('设为特殊案件', permList)
        || checkPermission('设为普通案件', permList)
        || checkPermission('移到中转站', permList)
        || checkPermission('历史处理记录:查看', permList)"
      id="_functionalAreasBlock"
      class="container-function marginBottom20"
    >
      <v-functionalAreas
        :case-info="caseInfo"
        :operation-list="operationList"
        @showHistory="showHistory"
        @fetchCaseInfo="fetchCaseInfo"
        @showdrawerbox="showdrawerbox"
        @showRuleAnswerContent="showRuleAnswerContent"
      />
    </section>

    <!-- 申请资料 -->
    <section id="_applicationMaterialsBlock" class="marginBottom5">
      <v-applicationMaterials
        :survey-pay-result="surveyPayResult"
        :audit-conclusion="answerRuleResult"
        @fetchCaseInfo="fetchCaseInfo"
      />
    </section>

    <!-- 公示信息 -->
    <section id="_publicityBlock">
      <div
        v-if="
          caseInfo &&
            caseInfo.publicityStart &&
            caseInfo.actualRaiseAmount &&
            caseInfo.raiseAmount &&
            caseInfo.transferTime &&
            checkPermission('公示中:公示信息', permList)
        "
        class="marginBottom20"
      >
        <v-publicity />
      </div>
    </section>

    <!-- 审核工作栏、用户信息栏、资料映像栏 -->
    <section id="_tabBlock" class="container-tab marginBottom20">
      <el-tabs
        v-model="tabCardName"
        type="border-card"
        stretch
        @tab-click="onClickTabBlock"
      >
        <el-tab-pane
          v-if="checkPermission('审核工作栏:查看', permList)"
          name="card1"
          label="审核工作栏"
        >
          <div class="content-block">
            <!-- 糅合类型答题（事件信息+答题） -->
            <v-examination @getcaseInfo="fetchCaseInfo" />
          </div>
        </el-tab-pane>
        <el-tab-pane name="card2" label="用户信息栏">
          <div class="content-block">
            <v-userinfo
              @getcaseInfo="fetchCaseInfo"
              @updateCaseOperationList="getCaseOperationList"
            />
          </div>
        </el-tab-pane>
        <el-tab-pane name="card3" label="资料映像栏">
          <div class="content-block images-info-block">
            <v-imageinfo
              :case-code="caseInfo.caseCode"
              :case-file-pic-list="caseFilePicList"
              :publicity-file-pic-list="publicityFilePicList"
              :assessment-survey-list="assessmentSurveyList"
              :close-file-pic-list="closeFilePicList"
              :scan-file-pic-list="scanFilePicList"
              :daily-photo-pic-list="dailyPhotoPicList"
              :plain-photo-pic-list="plainPhotoPicList"
              :s-m-s-photo-pic-list="SMSPhotoPicList"
              :receipt-photo-pic-list="receiptPhotoPicList"
              :thank-photo-pic-list="thankPhotoPicList"
              :tab-scroll-top="tabScrollTop"
              @getImageByCaseCode="getImageByCaseCode"
            />
          </div>
        </el-tab-pane>
      </el-tabs>
    </section>

    <!-- 疑点记录 -->
    <section
      v-if="answerList && answerList.length && checkPermission('疑点:查看', permList)"
      class="container-suspects marginBottom20"
    >
      <el-card class="content-block">
        <div slot="header" class="clearfix">
          <span class="bold">疑点记录</span>
        </div>
        <div class="item-block">
          <div class="search-con">
            <div v-for="(item, index) in answerList" :key="index">
              <v-answerItem
                :item="item"
                :index="index + 1"
                :case-code="caseInfo.caseCode"
                @updateCommunicates="updateCommunicates"
                @updateRuleSuspectData="getCaseRuleSuspectList"
                @updateCaseOperationList="getCaseOperationList"
              />
            </div>
            <div
              v-if="checkPermission('沟通备注:添加', permList)"
              class="button-block flex"
            >
              <el-button
                size="small"
                type="primary"
                icon="el-icon-upload"
                :disabled="isCaseArchive"
                @click="saveCommunicates"
              >
                保存
              </el-button>
            </div>
          </div>
        </div>
      </el-card>
    </section>

    <!-- 新增摘要内容（审核摘要、沟通摘要、客诉摘要） -->
    <v-abstract
      :appeals="appeals"
      :legal-affairs="legalAffairs"
      @getCaseAbstract="fetchCaseAbstract"
    />

    <!-- 审核记录、沟通记录、客诉记录 -->
    <section
      v-if="checkPermission('审核摘要:查看', permList)
        || checkPermission('沟通摘要:查看', permList)
        || checkPermission('客诉摘要:查看', permList)
        || checkPermission('法务摘要:查看', permList)"
      class="marginBottom20"
    >
      <v-summaryRecord
        :trial-data="trialData"
        :communicate-list="communicateList"
        :law-list="lawList"
        :legal-affair-list="legalAffairList"
        :appeals="appeals"
        :legal-affairs="legalAffairs"
      />
    </section>

    <!-- 拒付结论 -->
    <section
      v-if="(answerRuleResult.code == 1 || answerRuleResult.code == 2)
        && checkPermission('拒付结论:查看', permList)"
      class="container-protest marginBottom20"
    >
      <el-card class="content-block">
        <div slot="header" class="clearfix">
          <span class="bold">拒付结论</span>
        </div>
        <div class="item-block">
          <p class="list-title">审核结果：{{ answerRuleResult.name }}</p>
          <p
            v-for="(item, index) in answerRuleResult.reasons"
            :key="index"
            class="txt-list"
          >
            原因{{ index + 1 }}、{{ item }}
          </p>
        </div>
      </el-card>
    </section>

    <!-- 流程功能区 -->
    <section class="marginBottom20">
      <v-process-function
        :task-code="taskCode"
        :task-version="taskVersion"
        :answer-rule-result="answerRuleResult"
        @getcaseInfo="fetchCaseInfo"
        @showdrawerbox="showdrawerbox"
        @getCaseOperationList="getCaseOperationList"
      />
    </section>

    <!-- 表单组件（生成调查表、生成调查函） -->
    <router-view
      :cases="caseInfo"
      :showdrawer="showdrawer"
      :drawer-type="drawerType"
      :button-name="buttonName"
      :case-status="caseStatus"
      :remark="remark"
      :remark-array="remarkArray"
      @closedrawer="closedrawer"
      @getcaseInfo="fetchCaseInfo"
      @getImageByCaseCode="getImageByCaseCode"
    />

    <!-- 返回上一页-图标按钮 -->
    <span href class="detail-el-back" @click="back">
      <i class="el-icon-refresh-left" />
    </span>

    <!-- 返回页面顶部-图标按钮 -->
    <el-backtop target=".el-main" />
  </div>
</template>

<script>
import $ from 'jquery'
import { mapActions, mapState } from 'vuex'
import FunctionalAreas from './components/functionalAreas/index.vue' // 功能区域
import ApplicationMaterials from './components/applicationMaterials/index.vue' // 申请资料
import Publicity from './components/publicity/index.vue' // 公示信息
import Examination from './components/examination/index.vue' // 审核工作栏-答题
import UserInfo from './components/userInfo/index.vue' // 用户信息栏内容
import ImageInfo from './components/imageInfo/index.vue' // 资料映像栏内容
import AnswerItem from './components/answerItem/index.vue' // 疑点列表
import Abstract from './components/abstract/index.vue' // 新增摘要内容
import SummaryRecord from './components/summaryRecord/index.vue' // 摘要记录
import ProcessFunction from './components/processFunction/index.vue' // 流程功能区

export default {
  name: 'CaseDetailV2',
  components: {
    'v-functionalAreas': FunctionalAreas,
    'v-applicationMaterials': ApplicationMaterials,
    'v-publicity': Publicity,
    'v-examination': Examination,
    'v-userinfo': UserInfo,
    'v-imageinfo': ImageInfo,
    'v-answerItem': AnswerItem,
    'v-abstract': Abstract,
    'v-summaryRecord': SummaryRecord,
    'v-process-function': ProcessFunction
  },

  data() {
    return {
      caseInfo: {}, // 案件详情数据
      // 任务数据
      taskCode: '',
      taskVersion: '',
      surveyPayResult: '', // 是否需要调查
      auditConclusion: {}, // 审核结论
      answerRuleResult: {}, // 回答规则结果

      operationList: [], // 操作历史记录列表

      tabScrollTop: 0, // 审核工作栏、用户信息栏、资料映像栏-到顶部的距离（大约）
      tabCardName: 'card1', // 控制标签栏对应显示name
      // 资料映像数据
      caseFilePicList: [], // 案件资料
      publicityFilePicList: [], // 公示资料
      closeFilePicList: [], // 归档资料
      scanFilePicList: [], // 上传扫描件资料
      dailyPhotoPicList: [], // 日常照
      plainPhotoPicList: [], // 计划照
      SMSPhotoPicList: [], // 短信照
      receiptPhotoPicList: [], // 收据照
      thankPhotoPicList: [], // 感谢照
      assessmentSurveyList: [{ // 公估调查资料列表(2021年7月27日新增)
        title: '身份核查及面访材料',
        name: 'assessment_identity_verification',
        key: 'ValuationIdentityCheck',
        checkPermissions: '身份核查及面访材料:查看', // 查看权限
        editPermissions: '身份核查及面访材料:编辑', // 编辑权限
        toPMaterialPermissions: '身份核查及面访材料-转移到公示材料', // “转移到公示材料”的权限
        toAMaterialPermissions: '身份核查及面访材料-转移到归档材料', // “转移到归档材料”的权限
        deletePermissions: '身份核查及面访材料-图片:删除', // “删除资料”的权限
        children: []
      }, {
        title: '社保及商保材料',
        name: 'assessment_social_security',
        key: 'ValuationInsurance',
        checkPermissions: '社保及商保材料:查看', // 查看权限
        editPermissions: '社保及商保材料:编辑', // 编辑权限
        toPMaterialPermissions: '社保及商保材料-转移到公示材料', // “转移到公示材料”的权限
        toAMaterialPermissions: '社保及商保材料-转移到归档材料', // “转移到归档材料”的权限
        deletePermissions: '社保及商保材料-图片:删除', // “删除资料”的权限
        children: []
      }, {
        title: '医院排查材料',
        name: 'assessment_hospital_screening',
        key: 'ValuationHospital',
        checkPermissions: '医院排查材料:查看', // 查看权限
        editPermissions: '医院排查材料:编辑', // 编辑权限
        toPMaterialPermissions: '医院排查材料-转移到公示材料', // “转移到公示材料”的权限
        toAMaterialPermissions: '医院排查材料-转移到归档材料', // “转移到归档材料”的权限
        deletePermissions: '医院排查材料-图片:删除', // “删除资料”的权限
        children: []
      }, {
        title: '体检材料',
        name: 'assessment_medical',
        key: 'ValuationExam',
        checkPermissions: '体检材料:查看', // 查看权限
        editPermissions: '体检材料:编辑', // 编辑权限
        toPMaterialPermissions: '体检材料-转移到公示材料', // “转移到公示材料”的权限
        toAMaterialPermissions: '体检材料-转移到归档材料', // “转移到归档材料”的权限
        deletePermissions: '体检材料-图片:删除', // “删除资料”的权限
        children: []
      }, {
        title: '其他材料以及调查报告',
        name: 'assessment_other_materials',
        key: 'ValuationOtherSurvey',
        checkPermissions: '其他材料以及调查报告:查看', // 查看权限
        editPermissions: '其他材料以及调查报告:编辑', // 编辑权限
        toPMaterialPermissions: '其他材料以及调查报告-转移到公示材料', // “转移到公示材料”的权限
        toAMaterialPermissions: '其他材料以及调查报告-转移到归档材料', // “转移到归档材料”的权限
        deletePermissions: '其他材料以及调查报告-图片:删除', // “删除资料”的权限
        children: []
      }, {
        title: '既往材料及调查函',
        name: 'always_material',
        key: 'Valuation',
        checkPermissions: '既往材料及调查函:查看', // 查看权限
        editPermissions: '既往材料及调查函:编辑', // 编辑权限
        toPMaterialPermissions: '既往材料及调查函-转移到公示材料', // “转移到公示材料”的权限
        toAMaterialPermissions: '既往材料及调查函-转移到归档材料', // “转移到归档材料”的权限
        deletePermissions: '既往材料及调查函-图片:删除', // “删除资料”的权限
        children: []
      }],

      answerList: [], // 疑点列表
      suspectCommunicateInfos: [], // 怀疑交流信息

      // 摘要记录
      trialData: {}, // 审核摘要-列表内容
      communicateList: [], // 沟通摘要-列表内容
      lawList: [], // 客诉摘要-列表内容
      legalAffairList: [], // 法务摘要-列表内容
      appeals: {}, // 客诉记录基础信息
      legalAffairs: {}, // 法务记录基础信息

      // 抽屉弹出窗（生成调查表、生成调查函、查看历史处理记录-备注信息）
      showdrawer: false,
      drawerType: '',
      caseStatus: '',
      buttonName: '', // 按钮说明
      remark: '',
      remarkArray: []
    }
  },

  computed: {
    ...mapState({
      permList: (state) => state.permission.permList
    }),

    // 判断当前案件是否为“归档”流程
    isCaseArchive() {
      return this.caseInfo.flowCode >= 103500;
    },
  },

  created() {
    this.$emit('setCurrentMenu', '案件详情')
    this.fetchCaseInfo()
  },

  mounted() {
    const { permList } = this
    if (permList && permList.length && !this.checkPermission('审核工作栏:查看', permList)) {
      this.tabCardName = 'card2'
    }
  },

  // 组件销毁
  destroyed() {
    // 情况状态管理器中案件详情的信息
    this.setCaseInfo({})
  },

  methods: {
    ...mapActions({
      setCaseInfo: 'caseDetail/setCaseInfo'
    }),

    /**
     * 获取案件详情信息
     */
    async fetchCaseInfo() {
      const _this = this
      const { caseCode } = this.$route.params

      try {
        const { data: result } = await this.axios.get(
          `/case-info/information/${caseCode}`
        )

        if (result && result.status === '000000') {
          _this.caseInfo = result && result.data

          _this.setCaseInfo(result && result.data)
          _this.getCalcSurveyPay()
          _this.getCalcCaseRuleResult()
          _this.getTaskInfo()
          _this.getCaseOperationList()
          _this.getCaseRuleSuspectList()
          _this.getImageByCaseCode()
          _this.fetchCaseAbstract()
          _this.fetchContainerHeight()
        } else {
          _this.$alert(result && result.message, '提示', {
            callback: () => {
              _this.$router.push('/index/allcase')
            }
          })
        }
      } catch (error) {
        console.log('获取案件详情信息-请求失败', error)
      }
    },

    /**
     * 获取容器的高度
     */
    fetchContainerHeight() {
      const _this = this
      // 延迟获取，因为展示的内容需要先判断是否有权限
      setTimeout(() => {
        const functionalArea_h = $('#_functionalAreasBlock').outerHeight() || 0 // 功能区域的容器高度
        const applicationMaterials_h = $('#_applicationMaterialsBlock').outerHeight() || 0 // 基本信息的容器高度
        const publicityBlock_h = $('#_publicityBlock').outerHeight() || 0 // 公示信息的容器高度

        _this.tabScrollTop = Number(
          functionalArea_h + applicationMaterials_h + publicityBlock_h + 40
        )
      }, 1000)
    },

    /**
     * 计算调查和收费
     */
    async getCalcSurveyPay() {
      const _this = this
      const { caseCode, diseaseIcdInfo } = _this.caseInfo
      let { degreeCode, accidentType } = _this.caseInfo
      if (degreeCode == null) {
        degreeCode = ''
      }

      // 事故类型
      if (accidentType == null) {
        accidentType = ''
      }

      // icd编号
      let icdId = diseaseIcdInfo && diseaseIcdInfo.id
      if (icdId == null) icdId = ''

      try {
        const { data: result } = await _this.axios.get(
          `/case-info/cal-survey-pay?caseCode=${caseCode}&degreeCode=${degreeCode}&accidentType=${accidentType}&icdId=${icdId}`
        )
        const resData = result && result.data
        if (resData != null) {
          _this.surveyPayResult = result.survey === 1 ? '是' : '否'
          if (resData.chargeType != null) {
            _this.chareTypeList = resData.chargeType
          }
        }

        if (result.status !== '000000') {
          console.warn('计算调查和收费-请求失败', result && result.message)
          // _this.$alert((result && result.message) || '服务器繁忙，请稍后重试', '提示')
        }
      } catch (error) {
        console.log('计算调查和收费-请求失败', error)
      }
    },

    /**
     * 规则库-计算输出拒付理由
     */
    async getCalcCaseRuleResult() {
      // 计算结果
      const _this = this
      const { caseCode } = _this.caseInfo

      try {
        const { data: result } = await _this.axios.get(`/rule-answer/calc/${caseCode}`)
        if (result && result.status === '000000') {
          const auditConclusion = result.data
          _this.answerRuleResult = auditConclusion
        } else {
          console.warn('规则库-计算输出拒付理由-请求失败', result && result.message)
          // _this.$alert((result && result.message) || '服务器繁忙，请稍后重试', '提示')
        }
      } catch (error) {
        console.log('规则库-计算输出拒付理由-请求失败', error)
      }
    },

    /**
     * 获取任务信息
     */
    getTaskInfo() {
      const { from, taskCode, taskVersion } = this.$route.query

      if (from === 'task' || from === 'mytask' || from === 'myResearchTask') {
        this.taskCode = taskCode
        this.taskVersion = taskVersion + ''
      }
    },

    /**
     * 显示抽屉盒
     */
    showdrawerbox(type, buttonName, caseStatus) {
      this.showdrawer = true
      this.drawerType = type
      this.buttonName = buttonName
      this.caseStatus = caseStatus
    },

    /**
     * 关闭抽屉盒
     */
    closedrawer(close) {
      this.showdrawer = close
    },

    /**
     * 获取案件图片资料
     * @param {string} imageType  照片类型 附件annex 纸质扫描件 PaperScan 公估结果 PublicEstimate
     */
    async getImageByCaseCode(imageType = '') {
      const _this = this
      const { caseCode } = _this.caseInfo

      try {
        const { data: resData } = await _this.axios.get(
          `/casesCommon/getImageByCaseCode?imageType=${imageType}&caseCode=${caseCode}`
        )

        if (resData && resData.status === '000000') {
          const { result } = resData
          if (result) {
            const {
              Annex,
              PublicEstimate,
              CloseFile,
              Valuation,
              PaperScan,
              AddMaterialDailyPhoto,
              AddMaterialPlainPhoto,
              AddMaterialSMSPhoto,
              AddMaterialReceiptPhoto,
              AddMaterialThankPhoto,
              ValuationIdentityCheck,
              ValuationInsurance,
              ValuationHospital,
              ValuationExam,
              ValuationOtherSurvey
            } = result
            let { assessmentSurveyList } = _this

            _this.caseFilePicList = Annex || [] // 案件资料
            _this.publicityFilePicList = PublicEstimate || [] // 公示资料
            _this.closeFilePicList = CloseFile || [] // 归档资料
            _this.scanFilePicList = PaperScan || [] // 上传扫描件资料
            _this.dailyPhotoPicList = AddMaterialDailyPhoto || [] // 日常照
            _this.plainPhotoPicList = AddMaterialPlainPhoto || [] // 计划照
            _this.SMSPhotoPicList = AddMaterialSMSPhoto || [] // 短信照
            _this.receiptPhotoPicList = AddMaterialReceiptPhoto || [] // 收据照
            _this.thankPhotoPicList = AddMaterialThankPhoto || [] // 感谢照

            // 以下内容2021年7月27日新增
            assessmentSurveyList = assessmentSurveyList && assessmentSurveyList.map(item => {
              let children = []
              if (item.key === 'ValuationIdentityCheck' && ValuationIdentityCheck && ValuationIdentityCheck.length) { // 身份核查及面访材料
                children = ValuationIdentityCheck
              } else if (item.key === 'ValuationInsurance' && ValuationInsurance && ValuationInsurance.length) { // 社保及商保材料
                children = ValuationInsurance
              } else if (item.key === 'ValuationHospital' && ValuationHospital && ValuationHospital.length) { // 医院排查材料
                children = ValuationHospital
              } else if (item.key === 'ValuationExam' && ValuationExam && ValuationExam.length) { // 体检材料
                children = ValuationExam
              } else if (item.key === 'ValuationOtherSurvey' && ValuationOtherSurvey && ValuationOtherSurvey.length) { // 其他材料及调查报告
                children = ValuationOtherSurvey
              } else if (item.key === 'Valuation' && Valuation && Valuation.length) { // 既往材料及调查函
                children = Valuation
              }
              item.children = children
              return item
            })
            _this.assessmentSurveyList = assessmentSurveyList
          }
        } else {
          _this.$alert((resData && resData.message) || '服务器繁忙，请稍后重试', '提示', {
            callback: () => {
              _this.$router.push('/index/allcase')
            }
          })
        }
      } catch (error) {
        console.log('获取案件图片资料-请求失败', error)
      }
    },

    /**
     * 获取历史处理记录
     */
    async getCaseOperationList() {
      const _this = this
      const { caseCode } = _this.caseInfo

      try {
        const { data: result } = await _this.axios.get(
          `/case-operation-record/${caseCode}`
        )
        if (result && result.status === '000000') {
          const data = result.data
          _this.operationList = data
        } else {
          // _this.$alert(result && result.message, '提示', {
          //   callback: () => {
          //     _this.$router.push('/index/allcase')
          //   }
          // })
          console.warn('获取历史处理记录-请求失败', result && result.message)
        }
      } catch (error) {
        console.log('获取历史处理记录-请求失败', error)
      }
    },

    /**
     * 查看历史处理记录信息-备注-显示抽屉弹出窗
     * @param {Number} index 下标值
     */
    showHistory(index = 0) {
      const { operationList } = this
      const historyType = Number(operationList[index].type)
      const historyData = operationList[index].remark

      if (historyType === 2) {
        const { healthyDetail } = JSON.parse(historyData)
        const { listDetail } = JSON.parse(historyData)

        if (healthyDetail && healthyDetail.length > 0) {
          let result = ''
          let optionremark = ''
          healthyDetail.forEach((item, index) => {
            item.option.filter((zItem) => {
              if (zItem.checked) {
                result = zItem.tip
                optionremark = zItem.remark
              }
            })
            healthyDetail[index].result = result
            healthyDetail[index].optionremark = optionremark
          })
          this.remark = JSON.stringify(healthyDetail)
        }

        if ((listDetail && listDetail !== '') || listDetail != null) {
          this.remark = JSON.stringify(listDetail)
        }
      } else if (historyType === 5) {
        this.remark = JSON.parse(historyData)
      } else {
        this.remark = historyData
      }

      this.drawerType = String(historyType)
      this.showdrawer = true
    },

    /**
     * 查看历史处理记录信息-告知规则备注-显示抽屉弹出窗
     * @param {Number} index 下标值
     */
    showRuleAnswerContent(index = 0) {
      const { ruleAnswerContent } = this.operationList[index]
      this.remarkArray = JSON.parse(ruleAnswerContent)
      this.drawerType = '3'
      this.showdrawer = true
    },

    /**
     * 当前案件所有疑点列表
     */
    async getCaseRuleSuspectList() {
      const _this = this
      const { caseCode } = _this.caseInfo

      try {
        const { data: result } = await _this.axios.get(`/rule-suspect/${caseCode}`)
        if (result && result.status === '000000') {
          _this.answerList = result.data
        } else {
          // _this.$alert((result && result.message) || '服务器繁忙，请稍后重试', '提示')
          console.warn('当前案件所有疑点列表-请求失败', result && result.message)
        }
      } catch (error) {
        console.log('当前案件所有疑点列表-请求失败', error)
      }
    },

    /**
     * 沟通备注修改
     * @param {string} questionCode 疑点编号
     * @param {any} updateItem 更新内容
     */
    updateCommunicates(questionCode, updateItem) {
      const { suspectCommunicateInfos } = this
      const newCommunicateInfo = []
      let isExists = false

      // 循环当前所有沟通信息
      if (suspectCommunicateInfos && suspectCommunicateInfos.length > 0) {
        suspectCommunicateInfos.forEach((item) => {
          // 不更新这次问题答案
          if (item.questionCode !== questionCode) {
            newCommunicateInfo.push(item)
          } else {
            const currentQuestion = {
              questionCode,
              suspectRemarks: updateItem
            }
            newCommunicateInfo.push(currentQuestion)
            // 如果当前入参的内容已经写入到suspectCommunicateInfos中
            isExists = true
          }
        })
      }
      // 如果当前请求的入参未加入到suspectCommunicateInfos中，即要push一次
      if (!isExists) {
        const currentQuestion = {
          questionCode,
          suspectRemarks: updateItem
        }
        newCommunicateInfo.push(currentQuestion)
      }
      this.suspectCommunicateInfos = newCommunicateInfo
    },

    /**
     * 疑点记录-增加
     */
    async saveCommunicates() {
      const _this = this
      const {
        suspectCommunicateInfos,
        caseInfo: { caseCode }
      } = _this

      const newList = []
      suspectCommunicateInfos &&
        suspectCommunicateInfos.forEach((item) => {
          item &&
            item.suspectRemarks &&
            item.suspectRemarks.forEach((remarkItem) => {
              newList.push({
                questionCode: item.questionCode,
                suspectRemark: remarkItem.suspectRemark
              })
            })
        })

      try {
        const req = {
          caseCode,
          suspectCommunicateInfos: newList
        }
        const { data: result } = await _this.axios.post(
          `/rule-suspect-communicate/add`,
          req
        )
        if (result && result.status === '000000') {
          _this.$alert('操作成功', '提示', {
            callback: () => {
              _this.suspectCommunicateInfos = []
              _this.fetchCaseInfo()
            }
          })
        } else {
          _this.$alert(result && result.message, '提示')
        }
      } catch (error) {
        console.log('疑点记录-增加-请求失败', error)
      }
    },

    /**
     * 查询摘要内容
     */
    async fetchCaseAbstract() {
      const _this = this
      const {
        caseInfo: { caseCode }
      } = _this

      try {
        const { data: result } = await _this.axios.get(`/case-abstract/getCaseAbstract`, {
          params: { caseCode }
        })
        if (result && result.status === '000000') {
          const { trialData, lawList, communicateList, legalAffairList, appeals, legalAffairs } = result.data

          _this.trialData = trialData || {}
          _this.communicateList = communicateList || []
          _this.lawList = lawList || []
          _this.legalAffairList = legalAffairList || []
          if (appeals) _this.appeals = appeals // 客诉记录基础信息
          if (legalAffairs) _this.legalAffairs = legalAffairs // 法务记录基础信息
        } else {
          console.warn('摘要查询-请求失败', result && result.message)
          // _this.$alert(result && result.message, '提示')
        }
      } catch (error) {
        console.log('摘要查询-请求失败', error)
      }
    },

    /**
     * 审核工作栏、用户信息栏、资料映像栏-tab 被选中时触发
     */
    onClickTabBlock(tab) {
      const _this = this

      // 优化点击栏目的交互动作，增加滚动条滚动到指定位置效果
      setTimeout(() => {
        const { name } = tab
        const { tabScrollTop } = _this
        const elMain = $('.el-main')

        let sTop = tabScrollTop + 40
        if (name === 'card3') sTop += 1

        elMain.animate({ scrollTop: sTop }, 250)
      }, 100)
    },

    /**
     * 返回上一页
     */
    back() {
      const currentfrom = this.$route.query.from
      if (currentfrom === 'todo') {
        this.$router.push({
          path: '/index/todoCase',
          query: {
            from: 'casedetail'
          }
        })
      } else if (currentfrom === 'all') {
        this.$router.push({
          path: '/index/allcase',
          query: {
            from: 'casedetail'
          }
        })
      } else if (currentfrom === 'overtime') {
        this.$router.push({
          path: '/index/overtimeCase',
          query: {
            from: 'casedetail'
          }
        })
      } else if (currentfrom === 'task') {
        this.$router.push({
          path: '/index/task'
        })
      } else if (currentfrom === 'mytask') {
        this.$router.push({
          path: '/index/mytask'
        })
      } else if (currentfrom === 'myResearchTask') { // 我的调查任务
        this.$router.push({
          path: '/index/myResearchTask'
        })
      } else if (currentfrom === 'myemail') {
        this.$router.push({
          path: '/index/myemail'
        })
      } else {
        this.$router.push({
          path: '/index/allcase'
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/pages/caseDetailV2/index.scss";
</style>
